import { useTranslation } from "react-i18next"
import { X } from "@phosphor-icons/react"
import BetterDocIcon from "@/assets/images/icons/ic-better-doc.svg"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"

type BetterDocManualSearchBannerProps = {
  canEdit?: boolean
  onClear?: () => void
  "data-testid"?: string
}

const BetterDocManualSearchBanner = ({
  canEdit,
  onClear,
  "data-testid": dataTestId,
}: BetterDocManualSearchBannerProps) => {
  const { t } = useTranslation()
  return (
    <div
      data-testid={dataTestId}
      className={cn(
        "group border-border bg-surface flex w-full items-center justify-between rounded-xl border px-2 py-1",
        canEdit ? "hover:bg-surface-hovered" : "",
      )}>
      <div className="flex gap-2">
        <img className="h-10 w-10" src={BetterDocIcon} alt="better-doc-icon" />
        <div className="flex flex-col">
          <p className="text-on-surface text-sm leading-5">{t("episodeOfCare.betterDoc.manualSearch.title")}</p>
          <p className="text-on-surface-subdued text-xs tracking-[0.25px]">
            {t("episodeOfCare.betterDoc.manualSearch.subTitle")}
          </p>
        </div>
      </div>
      {canEdit && (
        <div className="flex opacity-0 group-hover:opacity-100">
          <Button className="h-10 w-10" variant="circle" type="button" onClick={onClear}>
            <X />
          </Button>
        </div>
      )}
    </div>
  )
}

export { BetterDocManualSearchBanner }
